// extracted by mini-css-extract-plugin
export default {"container":"Copyright_container__SC8kW","normalSize":"Copyright_normalSize__LyzAY","smallSize":"Copyright_smallSize__I0P3f"};